export interface UpdateStoreInformationModel {
  appId: string;
  updatePaymentDto: any;
  updateStoreInfoDto: any;
  updateShippingInfoDto: any;
}
